/* AirGrilles CFM & Grille Sizer  v3
   Bagimsiz calisir, tema JS'ine dokunmaz. Veri assets/cfm-sizer-data.json'dan gelir.

   v3 duzeltmeleri (2. inceleme):
   - Bant sinir hatasi: tam 400 FPM supply artik "Low" degil "Target range".
   - Statik basinc yayinlanmis aralik DISINDA uydurulmuyor; null donuyor ve
     "Outside published data" deniyor. Tum yayinlanmis noktalar arasinda interpolate ediliyor.
   - Opening finder'a Rectangle / Round secimi eklendi. Round-neck urunler
     dikdortgen aramada artik yanlislikla "Exact fit" cikmiyor.
   - Oda akisi merchandising kategorisine degil airflow function'a (fn) bakiyor;
     Commercial cone diffuser da supply terminali olarak degerlendiriliyor.
   - Damper / dryer vent / gable vent gibi terminal olmayan urunler (el=0) motora girmiyor.
   - Dil: "Preferred" -> "Target range", "Best fit" -> "Closest to target",
     "Lowest resistance" -> "Lowest published pressure drop", "Best value" -> "Lowest price".
*/
(function () {
  "use strict";
  var root = document.getElementById("cfmx");
  if (!root) return;

  var CDN = "https://cdn.shopify.com/s/files/";
  var DATA = { perf: [], sized: [], built: "" };

  var ROOMS = [
    { k: "bedroom", n: "Bedroom", ach: 5 },
    { k: "master", n: "Primary bedroom", ach: 5 },
    { k: "living", n: "Living room", ach: 6 },
    { k: "family", n: "Family room", ach: 6 },
    { k: "dining", n: "Dining room", ach: 6 },
    { k: "office", n: "Home office", ach: 6 },
    { k: "kitchen", n: "Kitchen", ach: 8, noReturn: 1 },
    { k: "bath", n: "Bathroom / toilet room", ach: 8, noReturn: 1 },
    { k: "laundry", n: "Laundry", ach: 7 },
    { k: "basement", n: "Basement", ach: 4 },
    { k: "garage", n: "Garage / shop", ach: 4, noReturn: 1 },
    { k: "hall", n: "Hallway", ach: 4 }
  ];

  /* Shopping target bantlari. Muhendislik hukmu DEGIL, alisveris hedefi.
     NC verisi veri setinde yok, bu yuzden ses iddiasi yapilmiyor.
     Sinirlar HER IKI UCTA DAHIL: supply 400-650 => tam 400 de tam 650 de Target range. */
  var ZONES = {
    S: { lo: 400, mid: 650, hi: 900 },
    R: { lo: 300, mid: 450, hi: 700 }
  };

  var S = {
    tab: "room", mode: "home", room: "bedroom",
    len: 14, wid: 12, hgt: 8, vtype: "S", vuse: "", cnt: 1,
    achManual: null, tv: 500, mat: "", stock: true,
    shape: "rect", ow: 12, oh: 6, od: 6, vtype2: "", vuse2: "",
    showAll: { room: false, back: false, size: false, near: false },
    list: []
  };

  /* Paylasilabilir baslangic durumu. Ornek:
       #cfmx:len=20,wid=14,hgt=9,room=living
       #cfmx:tab=size,shape=round,od=6
     Sadece kullanicinin zaten arayuzden ayarlayabildigi degerler; hepsi SINIRLANMIS.
     Not: eylem/tiklama calistiran bir kanca YOKTUR ve olmamalidir. */
  var LIMITS = { tv: [250, 900], len: [1, 200], wid: [1, 200], hgt: [6, 30],
                 ow: [2, 60], oh: [2, 60], od: [3, 30], cnt: [1, 4] };
  (function initFromHash() {
    var h = location.hash || "";
    if (h.indexOf("#cfmx:") !== 0) return;
    h.slice(6).split(",").slice(0, 12).forEach(function (kv) {
      var i = kv.indexOf("="); if (i < 0) return;
      var k = kv.slice(0, i), val = kv.slice(i + 1);
      if (k === "mode" && (val === "pro" || val === "home")) S.mode = val;
      else if (k === "tab" && (val === "room" || val === "size")) S.tab = val;
      else if (k === "shape" && (val === "rect" || val === "round")) S.shape = val;
      else if (k === "vtype" && (val === "S" || val === "R")) S.vtype = val;
      else if (k === "vtype2" && (val === "S" || val === "R" || val === "")) S.vtype2 = val;
      else if (k === "vuse2" && /^[cwfbue]?$/.test(val)) S.vuse2 = val;
      else if (k === "room" && ROOMS.some(function (r) { return r.k === val; })) S.room = val;
      else if (LIMITS[k]) {
        var n = num(val, LIMITS[k][0], LIMITS[k][1]);
        if (n != null) S[k] = n;
      }
    });
  })();

  function syncUI() {
    $("rtype").value = S.room;
    $("len").value = S.len; $("wid").value = S.wid; $("hgt").value = S.hgt;
    $("cnt").value = String(S.cnt);
    $("ow").value = S.ow; $("oh").value = S.oh; $("od").value = S.od;
    $("tv").value = S.tv; $("tvOut").textContent = S.tv + " FPM";
    $("ach").value = ach(); $("achOut").textContent = ach().toFixed(1);
    Array.prototype.forEach.call($("vtype").children, function (c) {
      c.setAttribute("aria-pressed", c.getAttribute("data-v") === S.vtype);
    });
    syncFinderChips();
    setShapeUI();
    root.setAttribute("data-mode", S.mode);
    $("mHome").setAttribute("aria-pressed", S.mode === "home");
    $("mPro").setAttribute("aria-pressed", S.mode === "pro");
    var t = S.tab;
    $("tabRoom").setAttribute("aria-selected", t === "room");
    $("tabSize").setAttribute("aria-selected", t === "size");
    $("formRoom").hidden = t !== "room"; $("formSize").hidden = t === "room";
    $("panelRoom").hidden = t !== "room"; $("panelSize").hidden = t === "room";
  }

  function $(id) { return root.querySelector("#cfmx-" + id); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function fmt(n) { return Math.round(n).toLocaleString("en-US"); }
  /* Sonlu + sinir kontrollu sayi. `> 0` yetmiyordu: Infinity geciyordu. */
  function num(v, lo, hi) {
    var n = parseFloat(v);
    if (!isFinite(n)) return null;
    return (n >= lo && n <= hi) ? n : null;
  }
  function round5(n) { return Math.round(n / 5) * 5; }
  function roomDef() { for (var i = 0; i < ROOMS.length; i++) if (ROOMS[i].k === S.room) return ROOMS[i]; return ROOMS[0]; }
  function ach() { return S.achManual != null ? S.achManual : roomDef().ach; }
  function targetV() { return S.mode === "pro" ? S.tv : (S.vtype === "R" ? 400 : 500); }
  function imgUrl(p) { return p.img ? CDN + p.img.slice(1) : null; }

  function calc() {
    var vol = S.len * S.wid * S.hgt, total = vol * ach() / 60, sqft = S.len * S.wid;
    return { vol: vol, sqft: sqft, total: total, each: total / S.cnt,
             perSqft: sqft ? total / sqft : 0, lo: total * 0.85, hi: total * 1.15 };
  }

  /* DUZELTME: her iki uc da dahil. Metin "400-650" diyorsa 650 de Target range olmali. */
  function band(v) {
    var z = ZONES[S.vtype] || ZONES.S;
    if (v < z.lo) return { cls: "b-low", label: "Low", rank: 1 };
    if (v <= z.mid) return { cls: "b-good", label: "Target range", rank: 0 };
    if (v <= z.hi) return { cls: "b-high", label: "High", rank: 1 };
    return { cls: "b-over", label: "Above range", rank: 9 };
  }

  /* DUZELTME: yayinlanmis aralik disinda uc degere sabitlemek YOK, null donuyor. */
  function spAt(p, v) {
    if (!p.sp) return null;
    var ks = Object.keys(p.sp).map(Number).sort(function (a, b) { return a - b; });
    if (!ks.length) return null;
    if (v < ks[0] || v > ks[ks.length - 1]) return null;      // aralik disi -> uydurma
    for (var i = 0; i < ks.length - 1; i++) {
      if (v >= ks[i] && v <= ks[i + 1]) {
        var a = p.sp[String(ks[i])], b = p.sp[String(ks[i + 1])];
        if (ks[i + 1] === ks[i]) return a;
        return a + (b - a) * (v - ks[i]) / (ks[i + 1] - ks[i]);
      }
    }
    return p.sp[String(ks[ks.length - 1])];
  }

  function inPublished(p, v) {
    if (p.vmin == null || p.vmax == null) return true;
    return v >= p.vmin && v <= p.vmax;
  }

  function candidates(each) {
    var tv = targetV(), out = [];
    for (var i = 0; i < DATA.perf.length; i++) {
      var p = DATA.perf[i];
      if (!p.el) continue;                       // damper / dryer vent vb. degil
      if (p.fn !== S.vtype) continue;            // merchandising kategorisi degil, hava fonksiyonu
      if (S.vuse && (p.u || "").indexOf(S.vuse) === -1) continue;
      if (S.mode === "pro") {
        if (S.mat && p.m !== S.mat) continue;
        if (S.stock && !p.i) continue;
      }
      var v = each / p.ak;
      out.push({ p: p, v: v, dv: Math.abs(v - tv), b: band(v),
                 sp: spAt(p, v), pub: inPublished(p, v) });
    }
    out.sort(function (a, b) {
      if (a.p.i !== b.p.i) return b.p.i - a.p.i;
      if (a.pub !== b.pub) return b.pub - a.pub;
      if (a.b.rank !== b.b.rank) return a.b.rank - b.b.rank;
      return a.dv - b.dv;
    });
    return out;
  }

  function picks(list) {
    /* DUZELTME: yayin araligi sarti HICBIR fallback'te dusmez.
       Onceki surumde son iki fallback `pub` sartini birakiyordu ve
       4.845 FPM gibi "Outside published data" urunler oneri olarak cikiyordu. */
    var base = list.filter(function (e) { return e.pub; });
    var stocked = base.filter(function (e) { return e.p.i; });
    if (!stocked.length) stocked = base;
    if (!stocked.length) return [];           // yayinlanmis veri yoksa ONERI YOK

    /* "Closest to target" = kullanicinin hedefine EN YAKIN olan, bant sirasindan bagimsiz.
       Onceki surum sabit Target range'i hedefin onune koyuyordu: hedef 900 FPM iken
       896 FPM'lik aday dururken 629 FPM seciliyordu ve aciklama yanlis oluyordu. */
    var pool = stocked;
    var out = [], used = {};
    function add(e, label, why) {
      if (!e || used[e.p.h]) return;
      used[e.p.h] = 1; out.push({ e: e, label: label, why: why });
    }
    var tv = targetV();
    var nearest = pool.slice().sort(function (a, b) { return a.dv - b.dv; })[0];
    add(nearest, "Closest to target",
        Math.round(nearest.v) + " FPM against a " + tv + " FPM target" +
        (nearest.b.rank === 0 ? "" : " (" + nearest.b.label.toLowerCase() + " band)"));
    /* diger iki oneri Target range icinden; yoksa genisle */
    var inBand = pool.filter(function (e) { return e.b.rank === 0; });
    if (!inBand.length) inBand = pool.filter(function (e) { return e.b.rank <= 1; });
    if (!inBand.length) inBand = pool;
    pool = inBand;
    var res = pool.filter(function (e) { return e.sp != null; })
      .sort(function (a, b) { return a.sp - b.sp; })[0];
    if (res) add(res, "Lowest published pressure drop", res.sp.toFixed(3) + " in. w.g. at this airflow");
    var val = pool.filter(function (e) { return e.p.p; })
      .sort(function (a, b) { return a.p.p - b.p.p; })[0];
    add(val, "Lowest price", val && val.p.p ? "$" + val.p.p.toFixed(2) + ", in stock" : "");
    return out;
  }

  function grilleSVG(p, size) {
    var s = size || 60, w = p.w || p.nk || 10, h = p.ht || p.nk || 6;
    var r = w / h, pad = 4, bw, bh;
    if (r >= 1) { bw = s - pad * 2; bh = Math.max(10, (s - pad * 2) / r); }
    else { bh = s - pad * 2; bw = Math.max(10, (s - pad * 2) * r); }
    var x = (s - bw) / 2, y = (s - bh) / 2, blades = "";
    var n = Math.max(3, Math.min(7, Math.round(bh / 6)));
    for (var i = 1; i < n; i++) {
      var yy = y + (bh / n) * i;
      blades += '<line x1="' + (x + 2.5).toFixed(1) + '" y1="' + yy.toFixed(1) + '" x2="' + (x + bw - 2.5).toFixed(1) + '" y2="' + yy.toFixed(1) + '" stroke="#3e8cc4" stroke-width="1.1" opacity=".55"/>';
    }
    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 ' + s + ' ' + s + '" aria-hidden="true">' +
      '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + bw.toFixed(1) + '" height="' + bh.toFixed(1) +
      '" rx="2" fill="none" stroke="#00446b" stroke-width="1.6" opacity=".85"/>' + blades + "</svg>";
  }

  function thumb(p) {
    var u = imgUrl(p);
    return u ? '<div class="cfmx-thumb"><img src="' + esc(u) + '" alt="" loading="lazy" width="70" height="70"></div>'
             : '<div class="cfmx-thumb">' + grilleSVG(p) + "</div>";
  }

  /* Round-neck urunlerde gosterilen olcu KANAL BAGLANTISI olmali, tavan paneli degil. */
  function sizeLabel(p) {
    if (p.nk) return p.nk + '" round neck' + (p.z ? " · fits " + p.z.replace(/"W x /, "×").replace(/"H/, '" grid') : "");
    return p.z;
  }

  function drawGauge(v) {
    var g = $("gauge"); if (!g) return;
    /* viewBox GERCEK piksel genisligine esitlenir. Onceden sabit 700 birimdi ve
       preserveAspectRatio="none" ile 768px'e esnetiliyordu: yazilar yatayda %10
       genisliyor, sisman ve bulanik gorunuyordu. Artik 1:1 ciziliyor. */
    var H = 78;
    var W = Math.round(g.getBoundingClientRect().width) || 700;
    g.setAttribute("viewBox", "0 0 " + W + " " + H);
    var y = 25, h = 20, max = 1000, MONO = "IBM Plex Mono, monospace";
    var zn = ZONES[S.vtype] || ZONES.S;
    /* ZONES {lo,mid,hi} nesnesi; bant listesi buradan turetilir. */
    var z = [[zn.lo, "Low", "#dde6ec", "#7a8b96"],
             [zn.mid, "Target range", "#3fae9c", "#0d6f61"],
             [zn.hi, "High", "#e0a03f", "#8a5300"],
             [max, "Above range", "#dc6f62", "#a02a20"]];
    var nx = v > 0 ? Math.min(v, max) / max * W : -999;
    var s = '<defs><clipPath id="cfmxBar"><rect x="0" y="' + y + '" width="' + W +
            '" height="' + h + '" rx="10"/></clipPath></defs>' +
            '<rect x="0" y="' + y + '" width="' + W + '" height="' + h +
            '" rx="10" fill="#f2f6f8"/><g clip-path="url(#cfmxBar)">';

    // bant dolgulari (yuvarlak uclar clipPath'ten geliyor)
    var prev = 0;
    z.forEach(function (zone, i) {
      var to = Math.min(zone[0], max), x1 = prev / max * W, x2 = to / max * W;
      s += '<rect x="' + x1.toFixed(1) + '" y="' + y + '" width="' + Math.max(0, x2 - x1).toFixed(1) +
           '" height="' + h + '" fill="' + zone[2] + '"/>';
      if (i > 0)   // bantlar arasi ince beyaz ayrac
        s += '<rect x="' + (x1 - 0.75).toFixed(1) + '" y="' + y + '" width="1.5" height="' + h + '" fill="#fff" opacity=".9"/>';
      prev = to;
    });
    s += '</g><rect x="0.5" y="' + (y + 0.5) + '" width="' + (W - 1) + '" height="' + (h - 1) +
         '" rx="9.5" fill="none" stroke="#c7d3dc" stroke-width="1"/>';

    // bant adlari (kendi renginin koyu tonunda)
    var p0 = 0;
    z.forEach(function (zone) {
      var to = Math.min(zone[0], max), mid = ((p0 + to) / 2) / max * W;
      if (to - p0 > 115 && Math.abs(mid - nx) > 52)
        s += '<text x="' + mid.toFixed(1) + '" y="15" font-size="10.5" font-weight="600" fill="' +
             zone[3] + '" text-anchor="middle" letter-spacing=".1em">' + zone[1].toUpperCase() + "</text>";
      p0 = to;
    });

    // sinir degerleri (iğnenin yakinindakiler gizlenir)
    prev = 0;
    z.forEach(function (zone) {
      var to = Math.min(zone[0], max), x2 = to / max * W;
      if (to < max && to > 0 && Math.abs(x2 - nx) > 34)
        s += '<text x="' + x2.toFixed(1) + '" y="64" font-size="12" font-weight="500" fill="#4a5c68"' +
             ' text-anchor="middle" font-family="' + MONO + '">' + to + "</text>";
      prev = to;
    });

    if (v > 0) {
      var cx = Math.max(24, Math.min(W - 24, nx));      // cip kenardan tasmasin
      s += '<g><line x1="' + nx.toFixed(1) + '" y1="19" x2="' + nx.toFixed(1) + '" y2="51"' +
           ' stroke="#1c2b34" stroke-width="2.6" stroke-linecap="round"/>' +
           '<rect x="' + (cx - 24).toFixed(1) + '" y="50" width="48" height="21" rx="6" fill="#1c2b34"/>' +
           /* data-needle: testler igneyi SUNUMA (font-weight) gore degil bu kalici
              isarete gore bulur. Onceden bant adlari da 600 olunca test kariyordu. */
           '<text data-needle="1" x="' + cx.toFixed(1) + '" y="64.5" font-size="12" font-weight="600"' +
           ' fill="#fff" text-anchor="middle" font-family="' + MONO + '">' + Math.round(v) + "</text></g>";
    }
    s += '<text x="0" y="15" font-size="10" font-weight="600" fill="#93a3ad" letter-spacing=".1em">FPM</text>';
    g.innerHTML = s;
  }

  function card(e, opts) {
    opts = opts || {};
    var p = e.p ? e.p : e, v = e.v, bits = [];
    if (v != null) {
      bits.push("<span><b>" + Math.round(v) + "</b> FPM</span>");
      bits.push('<span class="cfmx-badge ' + e.b.cls + '" style="padding:1px 7px;font-size:10.5px">' + e.b.label + "</span>");
      if (e.pub === false)
        bits.push('<span class="cfmx-badge b-over" style="padding:1px 7px;font-size:10.5px">Outside published data</span>');
    }
    if (opts.picked) bits.push('<span class="cfmx-badge b-pick" style="padding:1px 7px;font-size:10.5px">In our picks above</span>');
    if (opts.exact) bits.push('<span class="cfmx-badge b-good" style="padding:1px 7px;font-size:10.5px">Exact fit</span>');
    if (opts.near) bits.push('<span class="cfmx-badge b-high" style="padding:1px 7px;font-size:10.5px">Needs opening change</span>');
    /* Olcu sekmesinde oda hesabi yok; yine de urunun tasidigi debiyi goster.
       Referans hiz: return 400, supply 500 FPM. Verisi olmayanda satir cikmaz. */
    if (v == null && p.ak) {
      var refV = p.fn === "R" ? 400 : 500;
      bits.push("<span>carries <b>" + Math.round(p.ak * refV) + "</b> CFM at " + refV + " FPM</span>");
    }
    if (S.mode === "pro") {
      if (p.ak) bits.push("<span>A<sub>k</sub> <b>" + p.ak + "</b></span>");
      if (e.sp != null) bits.push("<span>Δp <b>" + e.sp.toFixed(3) + "</b></span>");
      /* DUZELTME: JSON alan adi 'throw', 'th' degil. 287 urunde veri var, hic gosterilmiyordu. */
      /* DUZELTME: throw sabit 500 kolonundan geliyordu. Artik calisma hizina EN YAKIN
         yayinlanmis noktayi aliyor ve hangi hiza ait oldugunu yaziyor. */
      if (p.throw && v != null) {
        var tk = Object.keys(p.throw).map(Number)
          .sort(function (a, b) { return Math.abs(a - v) - Math.abs(b - v); })[0];
        if (tk != null) bits.push("<span>published throw at " + tk + " FPM <b>" + p.throw[String(tk)] + "</b> ft</span>");
      }
    }
    /* "+N more": dikdortgen/yuvarlak olcusu olan urunlerde opening finder'a gecis;
       tek boyutlu (baseboard 15"/18"/24") urunlerde gecis YOK, sadece bilgi.
       Onceden bos olcu gonderip 12x6'ya dusuyordu. */
    if (opts.more) {
      if (p.nk)
        bits.push('<button type="button" class="cfmx-more" data-jump-round="' + p.nk + '">+' + opts.more + " more this size &rarr;</button>");
      else if (p.w && p.ht)
        bits.push('<button type="button" class="cfmx-more" data-jump-rect="' + p.w + "x" + p.ht + '">+' + opts.more + " more this size &rarr;</button>");
      else
        bits.push('<span style="color:#71838f">+' + opts.more + " more in this size</span>");
    }
    return '<a class="cfmx-card' + (opts.cls || "") + '" href="/products/' + esc(p.h) + '">' + thumb(p) +
      '<div class="cfmx-body">' +
      (opts.label ? '<div class="cfmx-pick"><b>' + esc(opts.label) + "</b>" + (opts.why ? "<span>" + esc(opts.why) + "</span>" : "") + "</div>" : "") +
      '<div class="cfmx-title">' + esc(p.t) + "</div>" +
      '<div class="cfmx-meta"><b>' + esc(sizeLabel(p)) + "</b><span>" + esc(p.k || "") + "</span>" +
      /* DUZELTME: availableForSale=false + inventoryPolicy=DENY = siparis alinmiyor. "Backorder" yanlisti. */
      (p.i ? "" : '<span style="color:#b26a01">out of stock</span>') +
      (p.p ? "<b>$" + p.p.toFixed(2) + "</b>" : "") + "</div>" +
      '<div class="cfmx-stats">' + bits.join("") + "</div></div></a>";
  }

  function syncReturnGate() {
    var rd = roomDef(), blocked = !!rd.noReturn;
    var chip = root.querySelector('#cfmx-vtype .cfmx-chip[data-v="R"]');
    var note = $("ircNote");
    if (chip) {
      chip.disabled = blocked;
      chip.style.opacity = blocked ? ".45" : "";
      chip.style.cursor = blocked ? "not-allowed" : "pointer";
    }
    if (blocked && S.vtype === "R") {
      S.vtype = "S";
      root.querySelector('#cfmx-vtype .cfmx-chip[data-v="R"]').setAttribute("aria-pressed", "false");
      root.querySelector('#cfmx-vtype .cfmx-chip[data-v="S"]').setAttribute("aria-pressed", "true");
    }
    note.hidden = !blocked;
    if (blocked) {
      note.innerHTML = "Return recommendations are disabled for this room type. IRC M1602.2 generally " +
        "prohibits returns from kitchens, toilet rooms and garages; stated exceptions and local " +
        "amendments may apply. Check with your local code official.";
    }
  }

  /* Range track'i tema yuzunden yerel olarak cizilmiyor; doluluk oranini
     CSS'e degisken olarak veriyoruz (bkz. cfm-sizer.css .cfmx-slider). */
  function sfill() {
    var s = root.querySelectorAll(".cfmx-slider");
    for (var i = 0; i < s.length; i++) {
      var el = s[i], mn = +el.min, mx = +el.max, v = +el.value;
      var f = (isFinite(mn) && isFinite(mx) && mx > mn && isFinite(v))
        ? Math.min(1, Math.max(0, (v - mn) / (mx - mn))) : 0;
      el.style.setProperty("--f", f.toFixed(4));
    }
  }

  function render() {
    sfill();
    if (S.tab === "size") { renderSize(); return; }
    var c = calc();
    $("cfmTotal").textContent = fmt(round5(c.total));
    $("cfmRange").textContent = "±15% shopping comparison range " + fmt(round5(c.lo)) + "–" + fmt(round5(c.hi));
    $("cfmEach").textContent = fmt(round5(c.each));
    $("volOut").textContent = fmt(c.vol);
    $("sqftOut").textContent = fmt(c.sqft);
    $("perSqft").textContent = c.perSqft.toFixed(2);

    var list = candidates(c.each);
    /* DUZELTME: gosterge, aciklama ve hassasiyet notu ONERIYLE AYNI URUNU anlatir.
       Onceden gosterge candidates()[0]'i (bant oncelikli) kullaniyordu, oneri ise hedefe
       en yakini; hedef 900 FPM iken gosterge 629, oneri 896 gosteriyordu. */
    var pk = picks(list);
    /* DUZELTME: oneri yoksa gosterge de "pick" sunmaz. Onceden list[0]'a dusup
       "Closest-to-target pick: 4845 FPM" yazarken altta "oneri yok" diyordu. */
    var best = pk.length ? pk[0].e : null, v = best ? best.v : 0;
    drawGauge(v);
    var b = best ? best.b : { cls: "b-low", label: "–" };
    var nb = $("noiseBadge"); nb.className = "cfmx-badge " + b.cls; nb.textContent = b.label;
    $("noiseNote").innerHTML = best
      ? "Closest-to-target pick: " + Math.round(v) + " FPM through a " + esc(sizeLabel(best.p)) + " " + (S.vtype === "R" ? "return grille" : "supply register") +
        " moving " + fmt(round5(c.each)) + " CFM. <em>For the same grille and configuration, lower velocity " +
        "generally reduces grille-generated noise, but actual sound depends on the product, the damper " +
        "position and the rest of the system. Published NC values are not part of this data set.</em>"
      : (list.length
          ? "No pick is shown: no product has published data covering this airflow. The scale above is for reference only."
          : "No grille matches these filters yet. Loosen a filter, or use the opening tab.");

    $("mathBody").innerHTML =
      '<div class="cfmx-eq">volume = ' + S.len + " ft &times; " + S.wid + " ft &times; " + S.hgt + " ft = " + fmt(c.vol) + " ft&sup3;</div>" +
      '<div class="cfmx-eq">CFM = ' + fmt(c.vol) + " ft&sup3; &times; " + ach() + " ACH &divide; 60 = <b>" + fmt(round5(c.total)) + " CFM</b></div>" +
      '<div class="cfmx-eq">per vent = ' + fmt(round5(c.total)) + " &divide; " + S.cnt + " = <b>" + fmt(round5(c.each)) + " CFM</b></div>" +
      (best ? '<div class="cfmx-eq">catalog velocity = ' + fmt(round5(c.each)) + " CFM &divide; " + best.p.ak + " ft&sup2; A<sub>k</sub> = <b>" + Math.round(v) + " FPM</b></div>" : "") +
      "<p style=\"margin:2px 0 0\">This is a <b>room-size planning estimate</b> from the air-changes-per-hour " +
      "method. It is neither a cooling nor a heating design airflow; actual design airflow may differ from both. " +
      "A <b>" + roomDef().n.toLowerCase() + "</b> is set to <b>" + ach() + " ACH</b>" +
      (S.achManual != null ? " (your override)" : "") + ", which works out to " + c.perSqft.toFixed(2) + " CFM per sq ft. " +
      "Room-by-room design airflow comes from an ACCA Manual J load calculation and Manual D duct design.</p>" +
      "<p style=\"margin:0\">The &plusmn;15% band is a <b>shopping comparison range, not a confidence interval</b>. " +
      "A<sub>k</sub> is the manufacturer&rsquo;s published <b>effective area factor</b> from its own test method, " +
      "which is not necessarily the same as geometric net free area, so the velocity above is a " +
      "<b>catalog velocity</b> for comparing products on the same basis.</p>";

    $("picks").innerHTML = pk.map(function (x) {
      return card(x.e, { label: x.label, why: x.why, cls: x.label === "Closest to target" ? " best" : "" });
    }).join("");
    $("picksWrap").hidden = !pk.length;

    /* Yayinlanmis veri hicbir urunu kapsamiyorsa acikca soyle. */
    var pubList = list.filter(function (e) { return e.pub; });
    var noPub = $("noPub");
    noPub.hidden = !!pubList.length || !list.length;
    if (!noPub.hidden) {
      noPub.innerHTML = "<b>No product has published data covering " + fmt(round5(c.each)) +
        " CFM per vent.</b> Every match below would run outside its manufacturer&rsquo;s tested range, " +
        "so performance there is unverified. Try splitting the airflow across more vents, " +
        "or have the system sized by a contractor.";
    }

    /* ±15% hassasiyeti: DUZELTME, CFM'i FPM bantlariyla karsilastiriyordu (birim hatasi).
       Dogru: secilen urunun Ak'sina bolerek iki uctaki KATALOG HIZINI bul. */
    var sens = $("sensNote");
    var top = pk.length ? pk[0].e : null;
    if (top && top.p.ak) {
      var vLo = c.lo / S.cnt / top.p.ak, vHi = c.hi / S.cnt / top.p.ak;
      var bLo = band(vLo), bHi = band(vHi);
      sens.hidden = bLo.label === bHi.label;
      if (!sens.hidden) {
        sens.innerHTML = "For <b>" + esc(sizeLabel(top.p)) + "</b> (the closest-to-target pick), the " +
          "&plusmn;15% comparison range spans <b>" + Math.round(vLo) + "&ndash;" + Math.round(vHi) +
          " FPM</b>, crossing from <b>" + bLo.label + "</b> to <b>" + bHi.label + "</b>. " +
          "The choice is sensitive to how accurate the room estimate is; measure the opening before you buy.";
      }
    } else {
      sens.hidden = true;
    }

    var inStock = [], back = [], seen = {}, seenB = {};
    list.forEach(function (e) {
      var key = sizeLabel(e.p);
      if (e.p.i) { if (!seen[key]) { seen[key] = { e: e, n: 0 }; inStock.push(seen[key]); } seen[key].n++; }
      else { if (!seenB[key]) { seenB[key] = { e: e, n: 0 }; back.push(seenB[key]); } seenB[key].n++; }
    });
    $("listHead").textContent = pubList.length ? "All sizes that carry this airflow"
                                              : "Products shown for size comparison only";
    /* Ust bloktaki 3 oneri URUN, asagidaki liste OLCU basina tek kart. Ayni sey iki kez
       yazilmis gibi okunmasin diye onerilen urunun olcusu asagida isaretlenir.
       Olcu etiketi uzerinden eslesir: o olcunun temsilci karti baska bir urun olabilir. */
    var pickSizes = {};
    pk.forEach(function (x) { pickSizes[sizeLabel(x.e.p)] = 1; });
    $("matchCount").textContent = list.length ? (inStock.length + back.length) + " sizes · " + list.length + " products" : "";
    var wrap = $("cards"), emp = $("cardsEmpty");
    if (!list.length) {
      wrap.innerHTML = ""; emp.hidden = false;
      emp.textContent = "Nothing matches those filters. Try “Any” for mounting location, or switch off in-stock-only.";
      $("backWrap").hidden = true;
      return;
    }
    emp.hidden = true;
    /* DUZELTME: onceki surum 9 ile kesip gerisine ulasim vermiyordu. */
    var capR = S.showAll.room ? inStock.length : 9;
    wrap.innerHTML = inStock.slice(0, capR).map(function (g) {
      return card(g.e, { more: g.n > 1 ? g.n - 1 : 0, picked: !!pickSizes[sizeLabel(g.e.p)] });
    }).join("")
      + moreBtn(inStock.length, capR, "room");
    $("backWrap").hidden = !back.length;
    var capB = S.showAll.back ? back.length : 6;
    $("backCards").innerHTML = back.slice(0, capB).map(function (g) { return card(g.e, { more: g.n > 1 ? g.n - 1 : 0 }); }).join("")
      + moreBtn(back.length, capB, "back");
  }

  function moreBtn(total, shown, key) {
    if (total <= shown) return "";
    return '<button type="button" class="cfmx-btn ghost cfmx-showall" data-showall="' + key + '">Show all ' +
      total + "</button>";
  }

  function renderSize() {
    var isRound = S.shape === "round", pool = [], acc = [];
    DATA.perf.concat(DATA.sized).forEach(function (p) {
      if (S.vtype2 && p.el && p.fn !== S.vtype2) return;
      if (S.vuse2 && (p.u || "").indexOf(S.vuse2) === -1) return;
      var exact, d;
      if (isRound) {
        if (!p.nk) return;                       // yuvarlak aramada sadece round-neck urunler
        exact = Math.abs(p.nk - S.od) < .01;
        d = Math.abs(p.nk - S.od);
      } else {
        if (p.nk) return;                        // DUZELTME: round-neck urun dikdortgen aramaya GIRMEZ
        if (!p.w || !p.ht) return;
        exact = (p.w === S.ow && p.ht === S.oh) || (p.w === S.oh && p.ht === S.ow);
        d = Math.min(Math.abs(p.w - S.ow) + Math.abs(p.ht - S.oh),
                     Math.abs(p.w - S.oh) + Math.abs(p.ht - S.ow));
      }
      /* DUZELTME: damper, dryer vent, gable vent hava terminali degil.
         Ana listede degil ayri "Accessories" bolumunde gosterilir. */
      (p.el ? pool : acc).push({ p: p, exact: exact, d: d });
    });
    function bySort(a, b) {
      if (a.exact !== b.exact) return b.exact - a.exact;
      if (a.p.i !== b.p.i) return b.p.i - a.p.i;
      return a.d - b.d;
    }
    pool.sort(bySort); acc.sort(bySort);
    var ex = pool.filter(function (x) { return x.exact; });
    var near = pool.filter(function (x) { return !x.exact; });
    var accEx = acc.filter(function (x) { return x.exact; });
    $("accWrap").hidden = !accEx.length;
    if (accEx.length) {
      $("accCards").innerHTML = accEx.slice(0, 6).map(function (e) {
        return card(e, { exact: true });
      }).join("");
    }
    var what = isRound ? S.od + '" round duct' : S.ow + '" × ' + S.oh + '" opening';
    $("sizeCount").textContent = ex.length ? ex.length + " products fit a " + what : "No exact match for a " + what;
    var wrap = $("sizeCards"), emp = $("sizeEmpty");
    if (!pool.length) {
      wrap.innerHTML = ""; emp.hidden = false;
      emp.textContent = isRound ? "No round-neck products match those filters."
                                : "No rectangular products match those filters.";
      $("nearWrap").hidden = true; return;
    }
    emp.hidden = true;
    /* DUZELTME: "24 products fit" deyip 12 gostermek satin alma akisini kesiyordu. */
    var capE = S.showAll.size ? ex.length : 12;
    wrap.innerHTML = (ex.slice(0, capE).map(function (e) { return card(e, { exact: true, cls: " best" }); }).join("")
      + moreBtn(ex.length, capE, "size"))
      || '<div class="cfmx-empty">Nothing matches that ' + (isRound ? "diameter" : "opening") +
         " exactly. The nearest sizes are below, but they need the opening or boot changed.</div>";
    $("nearWrap").hidden = !near.length;
    var capN = S.showAll.near ? near.length : 6;
    $("nearCards").innerHTML = near.slice(0, capN).map(function (e) { return card(e, { near: true }); }).join("")
      + moreBtn(near.length, capN, "near");
  }

  function renderRooms() {
    var p = $("roomsPanel");
    p.hidden = !S.list.length;
    $("roomRows").innerHTML = S.list.map(function (r, i) {
      return "<tr><td>" + esc(r.name) + "</td><td>" + (r.vt === "R" ? "Return" : "Supply") +
        '</td><td class="cfmx-num" style="font-size:12px">' + r.len + "×" + r.wid + "×" + r.hgt +
        ' ft</td><td class="n">' + r.ach + '</td><td class="n">' + fmt(round5(r.total)) + '</td><td class="n">' + r.cnt +
        '</td><td class="n">' + fmt(round5(r.each)) + '</td><td class="n"><button type="button" class="cfmx-btn ghost tiny" data-del="' + i + '">Remove</button></td></tr>';
    }).join("");
    $("roomTotal").textContent = fmt(round5(S.list.reduce(function (a, r) { return a + r.total; }, 0)));
  }

  /* ---------- wiring ---------- */
  function chipGroup(id, key, attr, after) {
    var el = $(id); if (!el) return;
    el.addEventListener("click", function (e) {
      var b = e.target.closest(".cfmx-chip"); if (!b || b.disabled) return;
      if (id === "fstock") { S.stock = !S.stock; b.setAttribute("aria-pressed", S.stock); render(); return; }
      Array.prototype.forEach.call(el.children, function (c) { c.setAttribute("aria-pressed", "false"); });
      b.setAttribute("aria-pressed", "true");
      S[key] = b.getAttribute("data-" + attr) || "";
      if (after) after();
      render();
    });
  }
  chipGroup("vtype", "vtype", "v"); chipGroup("vuse", "vuse", "u");
  chipGroup("vtype2", "vtype2", "v"); chipGroup("vuse2", "vuse2", "u");
  chipGroup("fmat", "mat", "m"); chipGroup("fstock", "stock", "s");
  chipGroup("shape", "shape", "sh", function () {
    var r = S.shape === "round";
    $("rectIn").hidden = r; $("roundIn").hidden = !r;
  });

  $("rtype").innerHTML = ROOMS.map(function (r) { return '<option value="' + r.k + '">' + r.n + "</option>"; }).join("");
  $("rtype").value = S.room;
  $("rtype").addEventListener("change", function (e) {
    S.room = e.target.value; S.achManual = null;
    $("ach").value = roomDef().ach; $("achOut").textContent = roomDef().ach.toFixed(1);
    syncReturnGate(); render();
  });
  [["len", "len"], ["wid", "wid"], ["hgt", "hgt"], ["ow", "ow"], ["oh", "oh"], ["od", "od"]].forEach(function (pair) {
    var el = $(pair[0]); if (!el) return;
    el.addEventListener("input", function (e) {
      var lim = LIMITS[pair[1]] || [0.1, 1e6];
      var v = num(e.target.value, lim[0], lim[1]);
      if (v != null) { S[pair[1]] = v; render(); }
    });
  });
  $("cnt").addEventListener("change", function (e) { S.cnt = +e.target.value; render(); });
  $("ach").addEventListener("input", function (e) { S.achManual = +e.target.value; $("achOut").textContent = (+e.target.value).toFixed(1); render(); });
  $("tv").addEventListener("input", function (e) { S.tv = +e.target.value; $("tvOut").textContent = e.target.value + " FPM"; render(); });

  /* Genislik degisince viewBox yeniden hesaplanmali (1:1 cizim). */
  var rzT = null;
  window.addEventListener("resize", function () {
    clearTimeout(rzT);
    rzT = setTimeout(function () { if (S.tab === "room") render(); }, 150);
  });

  $("mHome").addEventListener("click", function () { setMode("home"); });
  $("mPro").addEventListener("click", function () { setMode("pro"); });
  function setMode(m) {
    S.mode = m; root.setAttribute("data-mode", m);
    $("mHome").setAttribute("aria-pressed", m === "home");
    $("mPro").setAttribute("aria-pressed", m === "pro");
    render();
  }

  $("tabRoom").addEventListener("click", function () { setTab("room"); });
  $("tabSize").addEventListener("click", function () { setTab("size"); });
  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-goto-size]")) { e.preventDefault(); setTab("size"); return; }
    var sa = e.target.closest("[data-showall]");
    if (sa) { e.preventDefault(); S.showAll[sa.getAttribute("data-showall")] = true; render(); return; }
    /* "+N more this size": ayni olcuyu opening finder'da ac */
    var jr = e.target.closest("[data-jump-rect]");
    if (jr) {
      e.preventDefault(); e.stopPropagation();
      var wh = jr.getAttribute("data-jump-rect").split("x");
      jumpRect(parseFloat(wh[0]), parseFloat(wh[1])); return;
    }
    var jo = e.target.closest("[data-jump-round]");
    if (jo) {
      e.preventDefault(); e.stopPropagation();
      jumpRound(parseFloat(jo.getAttribute("data-jump-round"))); return;
    }
  });

  /* "+N more" gecisi olcuyu VE kaynak baglami (vent type + montaj) tasir.
     Onceden opening finder'daki eski Return/montaj filtresi kaliyor, tiklanan
     supply urunu acilan listede cikmiyordu. */
  function syncFinderChips() {
    Array.prototype.forEach.call($("vtype2").children, function (c) {
      c.setAttribute("aria-pressed", (c.getAttribute("data-v") || "") === S.vtype2);
    });
    Array.prototype.forEach.call($("vuse2").children, function (c) {
      c.setAttribute("aria-pressed", (c.getAttribute("data-u") || "") === S.vuse2);
    });
  }
  function carryContext() { S.vtype2 = S.vtype; S.vuse2 = S.vuse; syncFinderChips(); }
  function jumpRect(w, h) {
    var W = num(w, LIMITS.ow[0], LIMITS.ow[1]), Hh = num(h, LIMITS.oh[0], LIMITS.oh[1]);
    if (W == null || Hh == null) return;
    S.shape = "rect"; S.ow = W; S.oh = Hh; $("ow").value = W; $("oh").value = Hh;
    carryContext(); setShapeUI(); S.showAll.size = true; setTab("size");
  }
  function jumpRound(d) {
    var D = num(d, LIMITS.od[0], LIMITS.od[1]);
    if (D == null) return;
    S.shape = "round"; S.od = D; $("od").value = D;
    carryContext(); setShapeUI(); S.showAll.size = true; setTab("size");
  }
  function setShapeUI() {
    var r = S.shape === "round";
    Array.prototype.forEach.call($("shape").children, function (c) {
      c.setAttribute("aria-pressed", c.getAttribute("data-sh") === S.shape);
    });
    $("rectIn").hidden = r; $("roundIn").hidden = !r;
  }
  function setTab(t) {
    S.tab = t;
    $("tabRoom").setAttribute("aria-selected", t === "room");
    $("tabSize").setAttribute("aria-selected", t === "size");
    $("formRoom").hidden = t !== "room"; $("formSize").hidden = t === "room";
    $("panelRoom").hidden = t !== "room"; $("panelSize").hidden = t === "room";
    render();
  }

  $("addRoom").addEventListener("click", function () {
    var c = calc();
    /* Ayni oda adi tekrar eklenirse otomatik numaralanir (Bedroom, Bedroom 2).
       Satir vent tipini de saklar; toplam ODA debisidir, supply/return ayri toplanmaz. */
    var baseName = roomDef().n, name = baseName, k = 2;
    while (S.list.some(function (r) { return r.name === name; })) name = baseName + " " + (k++);
    S.list.push({ name: name, vt: S.vtype, len: S.len, wid: S.wid, hgt: S.hgt, ach: ach(), total: c.total, each: c.each, cnt: S.cnt });
    renderRooms();
  });
  $("roomRows").addEventListener("click", function (e) {
    var b = e.target.closest("[data-del]"); if (!b) return;
    S.list.splice(+b.getAttribute("data-del"), 1); renderRooms();
  });
  $("clearList").addEventListener("click", function () { S.list = []; renderRooms(); });
  $("copyList").addEventListener("click", function () {
    var lines = ["AirGrilles — room-size planning estimate (ACH method, not a Manual J load calculation)", ""];
    S.list.forEach(function (r) {
      lines.push(r.name + "  " + (r.vt === "R" ? "return" : "supply") + "  " + r.len + "x" + r.wid + "x" + r.hgt + " ft  " + r.ach + " ACH  " +
        round5(r.total) + " CFM  " + r.cnt + " vent(s)  " + round5(r.each) + " CFM each");
    });
    lines.push("", "TOTAL " + round5(S.list.reduce(function (a, r) { return a + r.total; }, 0)) + " CFM");
    var t = lines.join("\n"), btn = $("copyList");
    if (navigator.clipboard) navigator.clipboard.writeText(t).then(function () {
      btn.textContent = "Copied"; setTimeout(function () { btn.textContent = "Copy as text"; }, 1400);
    })["catch"](function () { });
  });

  /* Tesghis isareti: hangi asamada durdugunu gosterir. Davranisa etkisi yok,
     eylem calistirmaz; sadece durum yazar. Bir zaman asiminda "istek hala ucuyor mu,
     yoksa veri gelip render mi takildi" sorusu ancak bununla cevaplanabiliyor. */
  var T0 = Date.now();
  function phase(name) {
    root.setAttribute("data-phase", name);
    root.setAttribute("data-phase-ms", String(Date.now() - T0));
  }
  phase("fetching");

  fetch(root.getAttribute("data-src")).then(function (r) {
    phase("response-" + r.status);
    return r.json();
  }).then(function (d) {
    phase("parsed");
    DATA = d;
    var ld = $("loading"); if (ld) ld.hidden = true;
    var app = $("app"); if (app) app.hidden = false;
    var elig = DATA.perf.filter(function (p) { return p.el; }).length;
    $("dataNote").textContent = " " + elig + " air terminals carry that table; " +
      DATA.sized.filter(function (p) { return p.el; }).length +
      " more are matched by opening size on the second tab." +
      (DATA.built ? " Prices and stock last refreshed " + DATA.built + "." : "");
    phase("rendering");
    syncUI();
    syncReturnGate();
    render();
    phase("ready");
    root.setAttribute("data-ready", "1");        // kabul testi bunu bekler
  })["catch"](function (err) {
    phase("failed");
    root.setAttribute("data-error", String((err && err.message) || err).slice(0, 200));
    var ld = $("loading");
    if (ld) ld.textContent = "Could not load the product data. Please refresh the page.";
  });
})();
